export default {
  getCompanyHomeDetails: 'GET_COMPANY_HOME_DETAILS',
  getCompanyHomeDetailsSuccess: 'GET_COMPANY_HOME_DETAILS_SUCCESS',
  getCompanyHomeDetailsFailed: 'GET_COMPANY_HOME_DETAILS_FAILED',
  updateCompany: 'UPDATE_COMPANY',
  updateCompanySuccess: 'UPDATE_COMPANY_SUCCESS',
  updateCompanyFailed: 'UPDATE_COMPANY_FAILED',
};
